
import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-[#0E1A2B] overflow-hidden">
      {/* Large immersive background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e1d605cd4f6f7e5842730223ed1a1eb4.jpg"
          alt="Abstract technology background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0E1A2B]/80 via-[#0E1A2B]/60 to-[#0E1A2B]/90"></div>
      </div>

      {/* Animated floating orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/5 w-64 h-64 bg-[#2FB8AC]/8 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-[#4A6FA5]/6 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '2s' }}
        ></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2FB8AC]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center w-full">
        {/* Intelligence Mark Logo */}
        <div
          className={`flex justify-center mb-8 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div className="relative">
            <div className="absolute -inset-8 bg-[#2FB8AC]/15 rounded-full blur-2xl"></div>
            <div
              className="absolute -inset-4 bg-[#2FB8AC]/10 rounded-full blur-xl animate-pulse"
              style={{ animationDuration: '3s' }}
            ></div>
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/5f45847157c596b0dd69fa68df90550f.png"
              alt="Aivina Intelligence Mark"
              className="relative h-24 w-24 mx-auto"
            />
          </div>
        </div>

        {/* Headline */}
        <h1
          className={`text-5xl md:text-6xl lg:text-7xl font-semibold text-white mb-6 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.03em' }}
        >
          Intelligence that works<br className="hidden md:block" /> where it matters.
        </h1>

        {/* Subheadline */}
        <p
          className={`text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Aivina designs AI systems for healthcare clinics, law firms, and home service operators who require precision, compliance, and operational control.
        </p>

        {/* CTAs */}
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-600 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <a
            href="#contact"
            className="bg-[#2FB8AC] text-white px-8 py-3.5 rounded-md text-base font-medium hover:bg-[#28a89d] transition-all hover:shadow-lg hover:shadow-[#2FB8AC]/20 whitespace-nowrap cursor-pointer"
          >
            Schedule Strategy Call
          </a>
          <a
            href="#capabilities"
            className="border-2 border-white/30 text-white px-8 py-3.5 rounded-md text-base font-medium hover:bg-white/10 hover:border-white/50 transition-all whitespace-nowrap cursor-pointer"
          >
            View Capabilities
          </a>
        </div>

        {/* Scroll indicator */}
        <div className={`mt-16 transition-all duration-1000 delay-1000 ${isVisible ? 'opacity-60' : 'opacity-0'}`}>
          <div className="w-6 h-10 border-2 border-white/30 rounded-full mx-auto flex justify-center pt-2">
            <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
